import { Link } from 'gatsby';
import React, { useState } from 'react';
import renderLink from '~/utils/render-link';
import facebook from '~/icons/social/facebookalt.svg';
import twitter from '~/icons/social/twitter.svg';
import mail from '~/icons/social/mail.svg';
import linkedin from '~/icons/social/linkedin.svg';
import instagram from '~/icons/social/instagram.svg';

function SocialIcon({ type = 'facebook', url = '#' }) {
  const [onHover, setOnHover] = useState(false);
  return (
    <div>
      <Link to={renderLink(url)}>
        <div
          className="p-3 transition-colors duration-300 bg-transparent border rounded-full cursor-pointer border-opacity-30 border-grey hover:bg-blue hover:border-blue "
          onMouseEnter={() => setOnHover(true)}
          onMouseLeave={() => setOnHover(false)}
        >
          {type === 'twitter' ? (
            <img src={twitter} className={`object-contain w-5 h-5 ${onHover && 'filter invert'}`}></img>
          ) : type === 'mail' ? (
            <img src={mail} className={`object-contain w-5 h-5 ${onHover && 'filter invert'}`}></img>
          ) : type === 'linkedin' ? (
            <img src={linkedin} className={`object-contain w-5 h-5 ${onHover && 'filter invert'}`}></img>
          ) : type === 'instagram' ? (
            <img src={instagram} className={`object-contain w-5 h-5 ${onHover && 'filter invert'}`}></img>
          ) : (
            type === 'facebook' && (
              <img src={facebook} className={`object-contain w-5 h-5 ${onHover && 'filter invert'}`}></img>
            )
          )}
        </div>
      </Link>
    </div>
  );
}

export default SocialIcon;
